import { CALL_US_MODAL_NUMBER } from '../../../const/callUs';

export const callUsModalContent = {
  title: 'Questions about coverage?',
  getIntro: (brand: string) => `Speak with a ${brand} Protection Specialist who can help explain:`,
  points: [
    'What your manufacturer’s warranty covers - and what it doesn’t',
    'What’s covered, including accidental damage',
    'What options you may have if you already have appliance protection',
  ],
  cta: `Call ${CALL_US_MODAL_NUMBER}`,
};
